import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, Paper, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import preinformeStyles from '../preinforme/preinformeStyles';
import medicionesStyles from './medicionesStyles';

/**
 * Contenedor del patrón de panel: encabezado, formulario, mensaje de
 * resultado y botones Guardar y Limpiar con indicador de carga y,
 * opcionalmente, contenido bajo el formulario (`pie`).
 */
const PanelMedicion = ({
	modulo,
	guardando,
	bloqueado = false,
	resultado,
	onGuardar,
	onLimpiar,
	children,
	extra,
	pie,
}) => {
	const classes = medicionesStyles();
	const preinformeClasses = preinformeStyles();

	return (
		<Paper variant="outlined" className={classes.panelPaper}>
			<div className={classes.panelHeader}>
				<Typography variant="h6" component="h3" className={classes.panelTitle}>
					{modulo.label}
				</Typography>
				<Typography variant="body2" className={classes.panelDescripcion}>
					{modulo.descripcion}
				</Typography>
			</div>
			<form
				noValidate
				onSubmit={(e) => {
					e.preventDefault();
					onGuardar();
				}}
			>
				<div className={classes.panelCuerpo}>{children}</div>
				{resultado && (
					<Alert
						severity={resultado.ok ? 'success' : 'error'}
						role={resultado.ok ? 'status' : 'alert'}
					>
						{resultado.mensaje}
					</Alert>
				)}
				{extra}
				<div className={classes.panelAcciones}>
					{guardando && <CircularProgress size={20} aria-label="Guardando" />}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						disabled={guardando || bloqueado}
						className={preinformeClasses.buttonNoTransform}
					>
						Guardar
					</Button>
					<Button
						type="button"
						variant="outlined"
						color="primary"
						disabled={guardando}
						onClick={onLimpiar}
						className={preinformeClasses.buttonNoTransform}
					>
						Limpiar
					</Button>
				</div>
			</form>
			{pie}
		</Paper>
	);
};

PanelMedicion.propTypes = {
	modulo: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		descripcion: PropTypes.string,
	}).isRequired,
	guardando: PropTypes.bool,
	bloqueado: PropTypes.bool,
	resultado: PropTypes.shape({
		ok: PropTypes.bool,
		mensaje: PropTypes.string,
	}),
	onGuardar: PropTypes.func.isRequired,
	onLimpiar: PropTypes.func.isRequired,
	children: PropTypes.node,
	extra: PropTypes.node,
	pie: PropTypes.node,
};

export default PanelMedicion;
